"use client";

import { Feedback } from "@/components/feedback";
import { useStore } from "@/contexts/store";
import { share } from "@/app/(store)/_utils/share";
import { Container } from "@/components/container";
import { storeAnalitica } from "@/app/(store)/_utils/events";
import { useEffectOnce } from "@/hooks/use-effect-once";
import { MessageBuilder } from "@/utils/message-builder";
import { useExperiment } from "@/contexts/analitica";
import { ExperimentsFlags } from "@/services/amplitude/experiment";

const Error = () => {
  const { store, enabledWhatsAppSharing } = useStore();
  const showCartExperiment = useExperiment(ExperimentsFlags.ShowCart);
  const action = enabledWhatsAppSharing
    ? {
        action: {
          text: "Conversar com a loja",
          variant: "primary-solid" as const,
          icon: "brand-whatsapp" as const,
          onClick: () => {
            storeAnalitica.events.action.errorWhatsappClicked();

            share.whatsapp(
              store.vitrine.whatsAppNumber,
              MessageBuilder.buildCatalogGreeting(store.name, showCartExperiment)
            );
          },
        },
      }
    : {};

  useEffectOnce(() => {
    storeAnalitica.events.view.error();
  });

  return (
    <Container className="flex min-h-[calc(100vh-232px)] flex-col xl:min-h-[calc(100vh-276px)]">
      <Feedback
        icon="circle-error"
        title="Não foi possível carregar este catálogo"
        message="Você pode tentar de novo em alguns instantes. Se o problema continuar, converse com a loja."
        {...action}
      />
    </Container>
  );
};

export default Error;
